module.exports = __webpack_public_path__ + "img/participant.a919424a.png";